"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
class AtomicSwapHelpers {
    static async createPreimage() {
        const bytes = crypto_1.Random.getBytes(32);
        return bytes;
    }
    /** Creates a SHA256 hash of the preimage */
    static hashPreimage(preimage) {
        return new crypto_1.Sha256(preimage).digest();
    }
}
exports.AtomicSwapHelpers = AtomicSwapHelpers;
//# sourceMappingURL=atomicswaphelpers.js.map